import request from '@/request'
import store from '@/store'

/**
 * 登陆
 * @param data
 * @returns {AxiosPromise}
 */
export function LoginApi(data) {
  const url = '/api/v1/login'
  return request({ url, method: 'POST', data: data })
}

/**
 * 应用初始化
 * @returns {AxiosPromise}
 */
export function init() {
  const url = '/api/v1/init'
  return request({ url, method: 'POST' })
}
/**
 * 获取数据地区
 * @returns {AxiosPromise}
 */
export function AdminByAreaApi(data) {
  const url = '/api/v1/admin_by_area'
  return request({ url, method: 'POST', data: data })
}

/**
 * [更新当前用户信息]
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_info(data) {
  const url = '/api/v1/admin/modify_info'
  return request({ url, method: 'POST', data })
}

/**
 * 获取最新用户信息
 * @returns {axiosPromise}
 */
export function refreshUserInfo() {
  const url = '/api/v1/refresh_user_info'
  return request({ url, method: 'GET' })
}

/**
 * [ 获取我参与的活动的列表 ]
 * @param join_type
 * @param current
 * @param page_size
 * @returns {AxiosPromise}
 */
export function myJoinActivityList(join_type, current, page_size) {
  const url = '/api/v1/my_join_activity_list'
  return request({
    url,
    method: 'POST',
    data: {
      join_type: join_type,
      current,
      page_size,
    },
  })
}

// 根据层级获取地区信息
export function get_area(data) {
  const url = '/api/v1/area/get_area'
  return request({ url, method: 'get', params: data })
}

// 修改/新增 地区
export function modify_area(data) {
  const url = '/api/v1/area/modify'
  return request({ url, method: 'POST', data: data })
}

/**
 * 批量推送数据到 CRM
 * @param data
 * @returns {AxiosPromise}
 */
export function generalUser(data) {
  const url = '/api/v1/admin/c'
  return request({ url, method: 'post', data: data })
}

/**
 * 更新密码
 * @param data
 * @returns {AxiosPromise}
 */
export function modify_password(data) {
  const url = '/api/v1/admin/modify_password'
  return request({ url, method: 'post', data })
}

/**
 * 意见收集
 * @param data
 * @returns {AxiosPromise}
 */
export function idea(data) {
  const url = '/api/v1/idea'
  return request({ url, method: 'post', data: data })
}

/* 编辑器 */

/**
 * 获取分类中的数据
 * @returns {AxiosPromise}
 */
export function getCateList() {
  const url = '/api/v1/get_all_category_type'
  return request({ url, method: 'GET' })
}

/**
 * 针对book_sub_type 类型设置考试时间
 * @param data
 * @returns {AxiosPromise}
 */
export function setTestTime(data) {
  const url = '/api/v1/set_test_time'
  return request({ url, method: 'POST', data: data })
}

/**
 * 获取类型数据
 * @returns {AxiosPromise}
 */
export function categoryByType(params) {
  const url = '/api/v1/category_by_type'
  return request({ url, method: 'GET', params: params })
}

/**
 * 更新分类数据
 * @param data
 * @returns {AxiosPromise}
 */
export function type_change(data) {
  const url = '/api/v1/category/type_change'
  return request({ url, method: 'POST', data: data })
}

/**
 * 删除分类数据
 * @param data
 * @returns {AxiosPromise}
 */
export function type_delete(data) {
  const url = '/api/v1/category/type_delete'
  return request({ url, method: 'POST', data: data })
}

/**
 * 修改类型
 * @returns {AxiosPromise}
 */
export function categoryModify(data) {
  const url = '/api/v1/category_modify'
  return request({ url, method: 'POST', data: data })
}

/**
 * 获取学科门类
 * @returns {AxiosPromise}
 */
export function get_sub(type) {
  // 保存到 vuex 中
  const list = store.getters.subCategory
  if (list.length === 0) {
    const url = '/api/v1/category/get_sub'
    return request({ url, method: 'GET', params: { type } }).then((res) => {
      store.commit('SET_SUB_CATEGORY', res.list)
      return res
    })
  } else {
    return new Promise((resolve) => {
      resolve({ list, msg: '缓存中的数据', code: 1 })
    })
  }
}
/**
 * 获取素材分类
 * @returns {AxiosPromise}
 */
export function getEditorCate() {
  const url = '/api/v1/get_editor_category'
  return request({ url, method: 'GET' })
}

/**
 * 通过用户名搜索列表
 * @returns {AxiosPromise}
 */
export function admin_by_usernma(data) {
  const url = '/api/v1/admin/search_by_name'
  return request({ url, method: 'POST', data })
}
